// AI: justified because the generated client (`@app/api-client/generated`) is not
// available until `pnpm api:generate` has been run at least once. After the first
// generation, this file MUST be deleted and the generated hooks used instead.

import { apiAxios } from '@app/api-client';
import type {
  AuthEventDto,
  ChangePasswordInput,
  MyAuthEventQuery,
  Pagination,
  TrustedDeviceDto,
} from '@app/contracts';

export interface PaginatedAuthEvents {
  data: AuthEventDto[];
  pagination: Pagination;
}

export const changePassword = (data: ChangePasswordInput) =>
  apiAxios<{ revokedSessions: number }>({
    url: '/api/v1/auth/change-password',
    method: 'POST',
    data,
  });

export const fetchMyDevices = () =>
  apiAxios<TrustedDeviceDto[]>({ url: '/api/v1/auth/devices', method: 'GET' });

export const removeDevice = (id: string) =>
  apiAxios<{ revokedSessions: number }>({
    url: `/api/v1/auth/devices/${id}`,
    method: 'DELETE',
  });

export const fetchMyEvents = (params: MyAuthEventQuery) =>
  apiAxios<PaginatedAuthEvents>({
    url: '/api/v1/auth/events',
    method: 'GET',
    params,
  });

export const logoutAll = () =>
  apiAxios<{ revokedSessions: number }>({
    url: '/api/v1/auth/logout-all',
    method: 'POST',
  });
